import React, { Fragment, useCallback, useMemo, useState } from "react";

import {
  Chip,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
  IconButton,
} from "@mui/material";
import SubCard from "components/common/card/SubCard";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import UpdatePeopleCounterContainer from "containers/management/people-counter/UpdatePeopleCounter.container";
import HeadComponent from "../list/list-head/Head.component";
import { useTranslation } from "react-i18next";
import DialogComponent from "components/dialog/Dialog.component";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";

const PeopleCounterTable = ({
  item,
  isSuperUser,
  handleDeletePCount = () => { },
  setSuccess = () => { } }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [openEdit, setOpenEdit] = useState(false);

  const TABLE_HEAD = useMemo(
    () => [
      {
        id: "peopleCounter",
        label: t("People counter sensor"),
        alignRight: false, order: true
      },
      { id: "peopleCounterID", label: "ID ", alignRight: false, order: true },
      { id: "edit", label: " ", alignRight: false, order: true },
      { id: "delete", label: "", alignRight: false, order: true },
    ],
    [t]
  );

  const handleCloseDialog = useCallback(() => {
    setOpenEdit(false);
  }, []);

  const onEditClick = useCallback(
    (item) => {
      if (isSuperUser) {
        setOpenEdit(true);
      }
    },
    // eslint-disable-next-line
    [isSuperUser]
  );

  return (
    <TableContainer>
      <SubCard
        sx={{
          bgcolor: theme.palette.mode === "dark" ? "dark.800" : "grey.50",
          mb: 2,
        }}
        content={false}
      >
        <Table size="small" aria-label="purchases">
          <HeadComponent header={TABLE_HEAD} sx={{ fontSize: 12 }} />

          <TableBody>
            <TableRow
              sx={{
                "&:last-child td, &:last-child th": {
                  border: 0,
                },
              }}
            >
              <TableCell align="left">
                {item?.peopleCounter ? (
                  <Chip
                    label={t('Present')}
                    size='small'
                    sx={{
                      backgroundColor: "#B9F6CA",
                      color: "#00C853",
                    }}
                  />
                ) : (
                  <Chip label={t('absent')} size='small' />
                )}
              </TableCell>

              <TableCell
                align="left"
                sx={{ width: '1px', whiteSpace: 'nowrap' }}
              >
                {item?.peopleCounter &&
                  (item?.peopleCounterID ? (
                    item?.peopleCounterID
                  ) : (
                    <Chip label={t('None')} />
                  ))}
              </TableCell>

              {isSuperUser && item?.peopleCounter && (
                <Fragment>
                  <TableCell
                    align="right"
                    onClick={onEditClick}
                    sx={{ cursor: "pointer" }}
                  >
                    {item?.peopleCounterID ? (
                      <IconButton color="secondary" size="large">
                        <EditTwoToneIcon sx={{ fontSize: "1.3rem" }} />
                      </IconButton>
                    ) : (
                      <Button
                        size="small"
                        variant="contained"
                        onClick={onEditClick}
                      >
                        {t("Add Sensor")}
                      </Button>
                    )}
                  </TableCell>
                  {item?.peopleCounterID &&
                    <TableCell
                      align="right"
                      sx={{ width: '1px', whiteSpace: 'nowrap', cursor: "pointer" }}
                    >
                      {(
                        <DialogComponent
                          content={t(
                            "Are you sure you want to proceed with the deletion?"
                          )}
                          button={
                            <IconButton size="large">
                              <DeleteTwoToneIcon
                                style={{
                                  color:
                                    theme.palette.mode === "dark"
                                      ? theme.palette.secondary.main
                                      : theme.palette.primary.main,
                                }}
                              />
                            </IconButton>
                          }
                          onClickYes={() =>
                            handleDeletePCount({
                              station_id: item.stationId,
                              pcounter_id: item?.peopleCounterID,
                            })
                          }
                        />
                      )}
                    </TableCell>}
                </Fragment>
              )}
              {openEdit && (
                <UpdatePeopleCounterContainer
                  isSuperUser={isSuperUser}
                  open={openEdit}
                  data={item}
                  handleCloseDialog={handleCloseDialog}
                  setSuccess={setSuccess}
                />
              )}
            </TableRow>
          </TableBody>
        </Table>
      </SubCard>
    </TableContainer>
  );
};

export default PeopleCounterTable;
